import { Icon } from '@iconify/react';

import { usePwaInstallPromptContext } from '../../context';
import { Button } from '../Button';
import './AndroidPwaPrompt.scss';
export interface AndroidPwaPrompt {
  promptOnVisit: number;
  appIconPath?: string;
  closeLabel: string;
  description: string;
  installLabel: string;
  timesToShow: number;
  isShown: boolean;
  title: string;
}

/**
 * Chrome installs with its own dialog, opened from the offer it sent
 * (`beforeinstallprompt`): one Install button, not the iPhone's Share → Add to
 * Home Screen steps. Closing the sheet never opens that dialog.
 */
const AndroidPwaPrompt = ({
  appIconPath,
  closeLabel,
  description,
  installLabel,
  isShown,
  title,
}: AndroidPwaPrompt) => {
  const { deferredPrompt, setVisible } = usePwaInstallPromptContext();
  if (!isShown || !deferredPrompt) return null;
  const close = () => setVisible(false);
  function install() {
    if (!deferredPrompt) return;
    // An offer opens the dialog once; a second call rejects.
    deferredPrompt.prompt().catch(() => undefined);
    deferredPrompt.userChoice.then(close, close);
  }
  return (
    <div
      className="Mfw-AndroidPwaPrompt-overlay"
      data-testid="pwa-install-prompt-scrim"
      onClick={close}
    >
      <div
        className="Mfw-AndroidPwaPrompt-root"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="Mfw-AndroidPwaPrompt-header">
          <div className="Mfw-AndroidPwaPrompt-header-left">
            <img
              className="Mfw-AndroidPwaPrompt-icon"
              src={appIconPath}
              alt=""
            />
            <div className="Mfw-AndroidPwaPrompt-title-container">
              <span className="Mfw-AndroidPwaPrompt-title">{title}</span>
              <span className="Mfw-AndroidPwaPrompt-subtitle">
                {window.location.origin}
              </span>
            </div>
          </div>
          <button
            aria-label={closeLabel}
            className="Mfw-AndroidPwaPrompt-closeButton"
            data-testid="pwa-install-prompt-close"
            onClick={close}
          >
            <Icon icon="ic-baseline-close" height={24} width={24} />
          </button>
        </div>

        <div className="Mfw-AndroidPwaPrompt-description">{description}</div>

        <div className="Mfw-AndroidPwaPrompt-actions">
          <Button
            data-testid="pwa-install-prompt-install"
            fullWidth
            onClick={install}
            variant="contained"
          >
            {installLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default AndroidPwaPrompt;
